angular.module('bmsApp.resource')
	.factory('ResourceSvc', [
		'$log',
		'$q',
		'$window',
		'$modal',
		'notify',
		'$ngBootbox',
		'CRUDSvc',
		function ($log,
				  $q,
				  $window,
				  $modal,
				  notify,
				  $ngBootbox,
				  CRUDSvc) {

			// Directories -----------------------------------------------------

			function directoryRead(params) {
				return CRUDSvc.get('api/resource/directory/read', params);
			}

			function directorySave(params) {
				return CRUDSvc.post('api/resource/directory/save', params);
			}

			function directoryDelete(params) {
				return CRUDSvc.post('api/resource/directory/delete', params);
			}

			function directorySaveDialog(directory) {
				var modalInstance = $modal.open({
					templateUrl: 'ng/resource/templates/dialog/directory/ResourceDirectorySaveDialog.html',
					controller: 'ResourceDirectorySaveDialogCtrl',
					controllerAs: 'Save',
					size: 'sm',
					backdrop: 'static', // disable click-outside closing modal
					resolve: {
						directory: function () {
							return angular.copy(directory);
						}
					}
				});

				return modalInstance.result;
			}

			function directoryPinVerificationDialog(directory) {
				var modalInstance = $modal.open({
					templateUrl: 'ng/resource/templates/dialog/directory/ResourceDirectoryPinVerificationDialog.html',
					controller: 'ResourceDirectoryPinVerificationDialogCtrl',
					controllerAs: 'Save',
					size: 'sm',
					backdrop: 'static', // disable click-outside closing modal
					resolve: {
						directory: function () {
							return angular.copy(directory);
						}
					}
				});

				return modalInstance.result;
			}

			function directoryCreateDialog(parentDirectory) {
				var parent = parentDirectory ? {
					id: parentDirectory.id
				} : null;
				var directory = {
					parent: parent,
					name: 'Untitled folder'
				};

				return directorySaveDialog(directory);
			}

			function directoryUpdateDialog(directory) {
				return directorySaveDialog(directory);
			}

			function directoryMoveDialog(directory) {
				var modalInstance = $modal.open({
					templateUrl: 'ng/resource/templates/dialog/directory/ResourceDirectoryMoveDialog.html',
					controller: 'ResourceDirectoryMoveDialogCtrl',
					controllerAs: 'Move',
					size: 'md',
					backdrop: 'static', // disable click-outside closing modal
					resolve: {
						directory: function () {
							return angular.copy(directory);
						}
					}
				});

				return modalInstance.result;
			}

			function directoryDeleteDialog(directory) {
				var modalInstance = $modal.open({
					templateUrl: 'ng/resource/templates/dialog/directory/ResourceDirectoryDeleteDialog.html',
					controller: 'ResourceDirectoryDeleteDialogCtrl',
					controllerAs: 'Delete',
					size: 'md',
					backdrop: 'static', // disable click-outside closing modal
					resolve: {
						directory: function () {
							return angular.copy(directory);
						}
					}
				});

				return modalInstance.result;
			}

			// Resources -------------------------------------------------------

			function resourceRead(params) {
				return CRUDSvc.get('api/resource/resource/read', params);
			}

			function resourceSearch(params) {
				return CRUDSvc.get('api/resource/resource/search', params);
			}

			function resourceDownload(params) {
				CRUDSvc.open('resource/resource/download', params);
			}

			function resourceGetType(resource) {
				if ([
						'text/plain'
					].indexOf(resource.file.mime) > -1) {
					return 'text';
				}
				else if ([
						'image/bmp',
						'image/gif',
						'image/jpeg',
						'image/jpg',
						'image/png'
					].indexOf(resource.file.mime) > -1) {
					return 'image';
				}
				else if ([
						'video/mp4',
						'application/mp4',
						'video/x-msvideo',
						'video/ogg'
					].indexOf(resource.file.mime) > -1) {
					return 'video';
				}
				else if ([
						'application/pdf'
					].indexOf(resource.file.mime) > -1) {
					return 'pdf';
				}
				else if ([
						'application/msword',
						'application/vnd.openxmlformats-officedocument.wordprocessingml.document'
					].indexOf(resource.file.mime) > -1) {
					return 'doc';
				}
				else {
					return 'misc';
				}
			}

			function resourceUpdate(params) {
				return CRUDSvc.post('api/resource/resource/update', params);
			}

			function resourceDelete(params) {
				return CRUDSvc.post('api/resource/resource/delete', params);
			}

			function resourceUpdateStartEnd(params) {
				return CRUDSvc.post('api/resource/resource/update-start-end', params);
			}

			function resourceRenameDialog(resource) {
				var modalInstance = $modal.open({
					templateUrl: 'ng/resource/templates/dialog/resource/ResourceResourceRenameDialog.html',
					controller: 'ResourceResourceRenameDialogCtrl',
					controllerAs: 'Rename',
					size: 'sm',
					backdrop: 'static', // disable click-outside closing modal
					resolve: {
						resource: function () {
							return angular.copy(resource);
						}
					}
				});

				return modalInstance.result;
			}

			function resourceMoveDialog(resource) {
				var modalInstance = $modal.open({
					templateUrl: 'ng/resource/templates/dialog/resource/ResourceResourceMoveDialog.html',
					controller: 'ResourceResourceMoveDialogCtrl',
					controllerAs: 'Move',
					size: 'md',
					backdrop: 'static', // disable click-outside closing modal
					resolve: {
						resource: function () {
							return angular.copy(resource);
						}
					}
				});

				return modalInstance.result;
			}

			function resourceDeleteDialog(resource) {
				var modalInstance = $modal.open({
					templateUrl: 'ng/resource/templates/dialog/resource/ResourceResourceDeleteDialog.html',
					controller: 'ResourceResourceDeleteDialogCtrl',
					controllerAs: 'Delete',
					side: 'md',
					backdrop: 'static', // disable click-outside closing modal
					resolve: {
						resource: function () {
							return angular.copy(resource);
						}
					}
				});

				return modalInstance.result;
			}

			function resourceStartEndDialog(resourceOrFile, type) {
				var modalInstance = $modal.open({
					templateUrl: 'ng/resource/templates/dialog/temporal-resource-upload/TemporalResourceUpload.html',
					controller: 'TemporalResourceUploadModalCtrl',
					controllerAs: 'ModalCtrl',
					side: 'sm',
					backdrop: 'static', // disable click-outside closing modal
					resolve: {
						resourceOrFile: function () {
							return resourceOrFile;
						},
						type: function () {
							return type;
						},
					}
				});

				return modalInstance.result;
			}

			function resourceGenerateSigningUrl(params) {
				return CRUDSvc.get('api/resource/resource/generate-signing-url', {id: params.id});
			}

			// Receipts --------------------------------------------------------

			function receiptConfirm(params) {
				return CRUDSvc.post('api/resource/receipt/confirm', params);
			}

			// General ---------------------------------------------------------

			function displayErrors(errors) {
				angular.forEach(errors, function (error) {
					notify({
						message: error,
						classes: 'error',
						duration: 10000
					});
				});
			}

			return {
				directory: {
					read: directoryRead,
					save: directorySave,
					'delete': directoryDelete,
					createDialog: directoryCreateDialog,
					updateDialog: directoryUpdateDialog,
					moveDialog: directoryMoveDialog,
					deleteDialog: directoryDeleteDialog,
					pinVerificationDialog: directoryPinVerificationDialog,

				},
				resource: {
					read: resourceRead,
					resourceSearch: resourceSearch,
					download: resourceDownload,
					getType: resourceGetType,
					update: resourceUpdate,
					updateStartEnd: resourceUpdateStartEnd,
					'delete': resourceDelete,
					renameDialog: resourceRenameDialog,
					moveDialog: resourceMoveDialog,
					deleteDialog: resourceDeleteDialog,
					startEndDialog: resourceStartEndDialog,
					generateSigningUrl: resourceGenerateSigningUrl,
				},
				receipt: {
					confirm: receiptConfirm
				},
				displayErrors: displayErrors
			};

		}
	]);
